export default "__VITE_ASSET__bc0e0389__"